import { snackbarTypes } from "../../../../util/state/globalVariables";
import { commonPricingIntegrationErrorsManagement } from "../../utils";

/**
 * Handle errors of CheckIn - CheckOut
 */
export const checkInOutErrorsManagement = (error: any): {mess: string, snBarType: snackbarTypes} => {
    let mess = '';
    let snBarType = snackbarTypes.error;

    /*
     * LPP-21950 (SG-DAYS) — riquotazione degli accessori post-firma non disponibile sul riepilogo costi.
     *
     * NTW rifiuta la preview invece di mostrare un totale incompleto (che il cliente firmerebbe), e
     * risponde con AncillaryErrorResponse: { reason, message }. Il campo NON e' `errorDetails`, quindi
     * questi due casi non passano dagli switch sottostanti e senza questo blocco finirebbero nel
     * messaggio generico "riprovare piu' tardi".
     *
     * La distinzione fra i due motivi e' cio' che serve davvero all'operatore al banco:
     *  - REQUOTE_UNAVAILABLE   (503) Pricing non risponde: transitorio, RITENTARE ha senso -> warning;
     *  - REQUOTE_MISCONFIGURED (422) Pricing rifiuta il periodo: deterministico, ritentare NON serve,
     *                                va corretta la configurazione di listino -> error.
     *
     * In entrambi i casi il pulsante di avanzamento resta disabilitato da `flagError` (Summary.tsx), che
     * scatta su qualunque errore della preview: qui si decide soltanto cosa legge l'operatore.
     */
    switch (error.response?.data?.reason) {
        case 'REQUOTE_UNAVAILABLE':
            return {mess: 'common.error.ancillaryRequoteUnavailable', snBarType: snackbarTypes.warning};
        case 'REQUOTE_MISCONFIGURED':
            return {mess: 'common.error.ancillaryRequoteMisconfigured', snBarType: snackbarTypes.error};
        default:
            break;
    }

    if (error.response?.status === 400 &&
        [
            "\"ERROR_VEHICLE_NOT_INFLATED\"",
            "\"ERROR_PRICING_MISSING_CONFIGURATION\"",
            "\"ERROR_PRICING_BAD_CONFIGURATION\"",
            "\"ERROR_PRICING_NOT_SELLABLE\"",
            "\"ERROR_PRICING_NOT_CONFIGURED\"",
            "\"ERROR_CALLING_OPR_SERVICE\""
        ].includes(error.response?.data?.errorDetails)) 
    {
        switch (error.response?.data?.errorDetails) {
            case "\"ERROR_VEHICLE_NOT_INFLATED\"":
                mess = 'common.error.vehicleNotInflated';
                break;
            case "\"ERROR_PRICING_MISSING_CONFIGURATION\"":
                mess = 'common.error.pricingMissingConfiguration';
                break;
            case "\"ERROR_PRICING_BAD_CONFIGURATION\"":
                mess = 'common.error.pricingBadConfiguration';
                break;
            case "\"ERROR_PRICING_NOT_SELLABLE\"":
                mess = 'common.error.pricingNotSellable';
                snBarType = snackbarTypes.warning;
                break;
            case "\"ERROR_PRICING_NOT_CONFIGURED\"":
                mess = 'common.error.pricingNotConfigured';
                break;
            case "\"ERROR_CALLING_OPR_SERVICE\"":
                mess = 'common.error.callingOprService';
                break;
        }
    }

    if(!mess)
        mess = commonPricingIntegrationErrorsManagement(error) || 'translation:error.tryLater';

    return {
        mess,
        snBarType
    };
};